<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import facebookLogo from '../assets/social/facebook-logo.svg'
import instagramLogo from '../assets/social/instagram-logo.svg'
import behanceLogo from '../assets/social/behance-logo.svg'

import { TweenMax as Tween, Power1 } from 'gsap'

export default {

  name: 'TheMenu',

  data () {
    return {
      social: [
        { image: facebookLogo, name: 'facebook' },
        { image: instagramLogo, name: 'instagram' },
        { image: behanceLogo, name: 'behance' }
      ]
    }
  },

  computed: {
    lang () {
      return this.$route.params.lang
        ? this.$route.params.lang
        : 'ua'
    },

    links () {
      return this.$store.state.app.meta.pages
        .filter(page => !page.url.match(/main/))
    },

    gridSize () {
      return this.links.length <= 6
        ? this.links.length <= 4
          ? 'is-2'
          : 'is-3'
        : 'is-4'
    },

    lang () {
      return this.$route.params.lang
        ? this.$route.params.lang
        : 'ua'
    }
  },

  methods: {
    onLinkClick () {
      if (this.$store.getters.isPopupOpened) {
        this.$store.dispatch('closePopup', true)
      }
    },

    enter (el, done) {
      const wHeight = this.$store.state.app.window.height

      Tween.from(this.$refs.bg, 0.5, {
        y: -wHeight,
        ease: Power1.easeOut
      })

      Tween.staggerFrom(this.$refs.links, 0.2, {
        autoAlpha: 0,
        delay: 0.2
      }, 0.1)

      Tween.staggerFrom(this.$refs.social, 0.2, {
        autoAlpha: 0,
        delay: 0.4
      }, 0.05, done)
    },

    leave (el, done) {
      const wHeight = this.$store.state.app.window.height

      Tween.to(this.$refs.content, 0.1, {
        autoAlpha: 0
      })

      Tween.to(this.$refs.bg, 0.5, {
        y: wHeight,
        ease: Power1.easeOut,
        onComplete: () => {
          done()
        }
      })
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.menu-wrap
  .menu-background(ref="bg")

  .menu
      .menu-content(ref="content")
        .menu-grid(:class="gridSize")
          ul.menu-list
            li.menu-list__item(v-for="link in links" ref="links")
              router-link.menu-list__link(:to="'/' + lang + link.url", @click.native="onLinkClick")
                span {{ link.name }}

          footer.menu-bottom
            ul.social
              li.social__item(v-for="item in social" ref="social" v-if="$t(item.name + '-link').length > 0")
                a.social__link(:href="$t(item.name + '-link')" target="_blank")
                  img.social__icon(
                    :class="`is-${item.name}`"
                    :src="item.image"
                    :alt="`${item.name} logo`")

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.menu
  position absolute
  top 0
  left 0
  width 100vw
  height 100vh
  transform translateZ(0)
  // background #0052a6
  overflow auto
  +mobile()
    margin-top: 0

.menu-background
  z-index 1
  position absolute
  top 0
  left 0
  width 100%
  height 100%
  display: none
  +mobile()
    display: block
    height: 73px
    background: blue;

.menu-content
  z-index 2
  position absolute
  top 0
  left 0
  width 100%
  min-height 100%
  display flex
  flex-direction column
  justify-content space-between
  align-items center
  padding-top 108px
  padding-bottom 60px
  background-color blue
  +mobile()
    justify-content: center
    padding:73px 0 20px;
// ===========================================
// Top
// ===========================================

.menu-top
  width header-short-width
  height 60px
  display flex
  justify-content space-between
  align-items center

.menu-column
  display flex
  color white

// ===========================================
// Grid
// ===========================================

.menu-grid
  display flex
  flex-direction: column
  margin auto 0
  width 100%
  +mobile()
    margin 2px 0 0

.menu-list
  list-style-type none
  display grid
  grid-gap 2px
  margin 0 auto
  padding 0 65px
  max-width 1125px
  width 100%
  height 326px
  counter-reset links

  +tablet()
    padding 0 33px
  +mobile()
    height auto
    padding 0 24px

  .is-2 &
    grid-template-columns 1fr 1fr
    grid-template-row 1fr 1fr

    +mobile()
      grid-template-columns 1fr

  .is-3 &
    grid-template-columns 1fr 1fr 1fr
    grid-template-row 1fr 1fr

  .is-4 &
    grid-template-columns 1fr 1fr 1fr 1fr
    grid-template-row 1fr 1fr

  &__item
    position relative
    display flex
    z-index 1

    &:hover
      z-index 2

  &__link
    position relative
    display flex
    width 100%
    height 100%
    color rgba(white, .5)
    padding 70px 50px 0px

    +mobile()
      padding 20px 17px
      justify-content: center
      &:after
        display: none

    +above(1023px)
      &:hover
        color white
        transition color .3s

        &:after
          border-color white
          transition border-color .3s

    &:after
      content ''
      position absolute
      top -2px
      left -2px
      width calc(100% + 4px)
      height calc(100% + 4px)
      border 2px solid #6697c9

    span
      position relative
      font-size 24px
      font-weight 500

      &:before
        content counter(links, decimal-leading-zero)
        counter-increment links
        position absolute
        left 2px
        top -25px
        font-size 10px

      +mobile()
        font-size: 18px

        &:before
          display: none

// ===========================================
// Bottom
// ===========================================

.menu-bottom
  display flex
  justify-content center
  align-items center
  margin-top: 30px
  +mobile()
    margin-bottom: 0

.social
  list-style none
  display flex

  &__item
    display flex
    padding 0 5px

  &__link
    display flex
    justify-content center
    align-items center
    width 50px
    height 50px

  &__icon
    max-height 20px

    &.is-behance
      max-height 23px

@media (min-height 568px) and (max-height 700px) and (min-width 768px)
  .menu-grid
    margin 0
  .menu-list
    height 270px
    &__link
      padding 60px 50px 0

</style>



// WEBPACK FOOTER //
// the-menu.vue?a8215a9e